'use strict';

function isUndefined(o) {
  return o === undefined;
}

module.exports = isUndefined;


// WEBPACK FOOTER //
// ./~/sugar-date/common/internal/isUndefined.js